/*
 * assets/vp-filtro.js
 * Filtro reusável (Categoria / Tamanho / Preço) para a section
 * vitrine-produtos.liquid. Roda 100% no navegador (client-side).
 *
 * NOVO: fica sincronizado com o botão "Carregar mais" (vp-loadmore.js).
 * Sempre que novos produtos são adicionados na grade, window.__vpRescanFilter
 * é chamado pra essa seção, recalculando contagens, adicionando novas
 * opções de Categoria/Tamanho que ainda não existiam, e atualizando o
 * filtro pra considerar TODOS os produtos já carregados — não só os da
 * primeira leva.
 */
(function () {
  if (window.__vpFiltroInit) return;
  window.__vpFiltroInit = true;
  window.__vpRescanFilter = window.__vpRescanFilter || {};

  function normalizeSize(raw) {
    return (raw || '').trim();
  }

  function displaySize(token) {
    if (!token) return token;
    if (token.indexOf('-') > -1 && /\d/.test(token)) return token; // "34-38" fica como está
    return token.toUpperCase(); // letras: pp -> PP
  }

  function initFilterBar(bar) {
    var sectionId = bar.getAttribute('data-vp-filter-for');
    var wrapper = document.getElementById('shopify-section-' + sectionId);
    if (!wrapper) return;

    function collectData() {
      var liveCards = Array.prototype.slice.call(wrapper.querySelectorAll('.vp-card'));
      var typeSet = {};
      var sizeSet = {};
      var minPrice = Infinity;
      var maxPrice = 0;

      liveCards.forEach(function (card) {
        var type = card.getAttribute('data-vp-type');
        if (type) typeSet[type] = (typeSet[type] || 0) + 1;

        var sizesAttr = card.getAttribute('data-vp-sizes') || '';
        sizesAttr.split(',').forEach(function (s) {
          var n = normalizeSize(s);
          if (n) sizeSet[n] = (sizeSet[n] || 0) + 1;
        });

        var price = parseInt(card.getAttribute('data-vp-price'), 10);
        if (!isNaN(price)) {
          if (price < minPrice) minPrice = price;
          if (price > maxPrice) maxPrice = price;
        }
      });

      if (minPrice === Infinity) minPrice = 0;

      var types = Object.keys(typeSet).sort();
      var sizes = Object.keys(sizeSet).sort(function (a, b) {
        var order = ['pp', 'p', 'm', 'g', 'gg', 'u'];
        var ai = order.indexOf(a), bi = order.indexOf(b);
        if (ai > -1 && bi > -1) return ai - bi;
        if (ai > -1) return -1;
        if (bi > -1) return 1;
        return a.localeCompare(b);
      });

      return { cards: liveCards, typeSet: typeSet, sizeSet: sizeSet, types: types, sizes: sizes, minPrice: minPrice, maxPrice: maxPrice };
    }

    var initialData = collectData();
    if (!initialData.cards.length) return;

    var state = { types: [], sizes: [], priceMin: null, priceMax: null };

    var html = '<div class="vp-filter-group">';

    if (initialData.types.length > 1) {
      html += buildPillWithPanel('categoria', 'Categoria', initialData.types, initialData.typeSet, false);
    }
    if (initialData.sizes.length > 1) {
      html += buildPillWithPanel('tamanho', 'Tamanho', initialData.sizes, initialData.sizeSet, true);
    }
    if (initialData.maxPrice > initialData.minPrice) {
      html += ''
        + '<div class="vp-filter-pill vp-filter-price-pill">'
        + '<span>Preço</span>'
        + '<div class="vp-filter-price">'
        + '<input type="number" inputmode="numeric" class="vp-price-min" placeholder="' + Math.floor(initialData.minPrice / 100) + '" min="0">'
        + '<span>—</span>'
        + '<input type="number" inputmode="numeric" class="vp-price-max" placeholder="' + Math.ceil(initialData.maxPrice / 100) + '" min="0">'
        + '<button type="button" class="vp-filter-price-ok">OK</button>'
        + '</div>'
        + '</div>';
    }

    html += '</div>';
    html += '<button type="button" class="vp-filter-clear">limpar filtros</button>';
    html += '<span class="vp-filter-count"></span>';

    bar.innerHTML = html;

    var grid = wrapper.querySelector('.vp-grid, .vp-carousel');
    var emptyState = wrapper.querySelector('.vp-empty-state');
    if (!emptyState && grid) {
      emptyState = document.createElement('p');
      emptyState.className = 'vp-empty-state';
      emptyState.textContent = 'Nenhum produto encontrado com esses filtros';
      grid.parentNode.insertBefore(emptyState, grid.nextSibling);
    }

    function buildPillWithPanel(key, label, values, countMap, isSize) {
      var options = values.map(function (v) {
        var text = isSize ? displaySize(v) : v;
        return ''
          + '<label class="vp-filter-option">'
          + '<input type="checkbox" data-key="' + key + '" value="' + v.replace(/"/g, '&quot;') + '">'
          + '<span>' + text + '</span>'
          + '<span class="vp-filter-pill__count">(' + countMap[v] + ')</span>'
          + '</label>';
      }).join('');

      return ''
        + '<div class="vp-filter-dropdown" data-filter-key="' + key + '">'
        + '<button type="button" class="vp-filter-pill" data-toggle="' + key + '">' + label + '</button>'
        + '<div class="vp-filter-panel" data-panel="' + key + '">'
        + '<div class="vp-filter-panel-header"><span>' + label + '</span><button type="button" class="vp-filter-panel-close" data-close="' + key + '" aria-label="Fechar">\u00d7</button></div>'
        + options
        + '</div>'
        + '</div>';
    }

    function bindToggle(btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var key = btn.getAttribute('data-toggle');
        var panel = bar.querySelector('[data-panel="' + key + '"]');
        var wasOpen = panel.classList.contains('is-open');
        bar.querySelectorAll('.vp-filter-panel').forEach(function (p) { p.classList.remove('is-open'); });
        if (!wasOpen) panel.classList.add('is-open');
      });
    }

    function bindCheckbox(input) {
      input.addEventListener('change', function () {
        var key = input.getAttribute('data-key');
        var arr = state[key === 'categoria' ? 'types' : 'sizes'];
        if (input.checked) {
          arr.push(input.value);
        } else {
          var idx = arr.indexOf(input.value);
          if (idx > -1) arr.splice(idx, 1);
        }
        updatePillActive(key);
        applyFilters();
      });
    }

    bar.querySelectorAll('[data-toggle]').forEach(bindToggle);

    bar.querySelectorAll('.vp-filter-panel').forEach(function (panel) {
      panel.addEventListener('click', function (e) { e.stopPropagation(); });
    });

    bar.querySelectorAll('[data-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var key = btn.getAttribute('data-close');
        var panel = bar.querySelector('[data-panel="' + key + '"]');
        if (panel) panel.classList.remove('is-open');
      });
    });

    document.addEventListener('click', function () {
      bar.querySelectorAll('.vp-filter-panel').forEach(function (p) { p.classList.remove('is-open'); });
    });

    bar.querySelectorAll('input[type="checkbox"]').forEach(bindCheckbox);

    var priceMinInput = bar.querySelector('.vp-price-min');
    var priceMaxInput = bar.querySelector('.vp-price-max');
    var priceOkBtn = bar.querySelector('.vp-filter-price-ok');

    function commitPrice() {
      state.priceMin = priceMinInput.value ? parseFloat(priceMinInput.value) * 100 : null;
      state.priceMax = priceMaxInput.value ? parseFloat(priceMaxInput.value) * 100 : null;
      updatePricePillActive();
      applyFilters();
      priceMinInput.blur();
      priceMaxInput.blur();
    }

    if (priceMinInput) {
      priceMinInput.addEventListener('input', debounce(commitPrice, 350));
    }
    if (priceMaxInput) {
      priceMaxInput.addEventListener('input', debounce(commitPrice, 350));
    }
    if (priceOkBtn) {
      priceOkBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        commitPrice();
      });
    }

    var clearBtn = bar.querySelector('.vp-filter-clear');
    clearBtn.addEventListener('click', function () {
      state = { types: [], sizes: [], priceMin: null, priceMax: null };
      bar.querySelectorAll('input[type="checkbox"]').forEach(function (i) { i.checked = false; });
      if (priceMinInput) priceMinInput.value = '';
      if (priceMaxInput) priceMaxInput.value = '';
      bar.querySelectorAll('.vp-filter-pill').forEach(function (p) { p.classList.remove('is-active'); });
      applyFilters();
    });

    function updatePillActive(key) {
      var pillBtn = bar.querySelector('[data-toggle="' + key + '"]');
      var arr = state[key === 'categoria' ? 'types' : 'sizes'];
      if (pillBtn) pillBtn.classList.toggle('is-active', arr.length > 0);
    }

    function updatePricePillActive() {
      var pill = bar.querySelector('.vp-filter-price-pill');
      if (pill) pill.classList.toggle('is-active', state.priceMin !== null || state.priceMax !== null);
    }

    function debounce(fn, wait) {
      var t;
      return function () {
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(null, args); }, wait);
      };
    }

    function applyFilters() {
      var liveCards = wrapper.querySelectorAll('.vp-card');
      var visibleCount = 0;
      liveCards.forEach(function (card) {
        var type = card.getAttribute('data-vp-type') || '';
        var cardSizes = (card.getAttribute('data-vp-sizes') || '').split(',').map(normalizeSize);
        var price = parseInt(card.getAttribute('data-vp-price'), 10);

        var matchType = state.types.length === 0 || state.types.indexOf(type) > -1;
        var matchSize = state.sizes.length === 0 || state.sizes.some(function (s) { return cardSizes.indexOf(s) > -1; });
        var matchPriceMin = state.priceMin === null || price >= state.priceMin;
        var matchPriceMax = state.priceMax === null || price <= state.priceMax;

        var match = matchType && matchSize && matchPriceMin && matchPriceMax;
        card.style.display = match ? '' : 'none';
        if (match) visibleCount++;
      });

      var countEl = bar.querySelector('.vp-filter-count');
      if (countEl) countEl.textContent = visibleCount + (visibleCount === 1 ? ' produto' : ' produtos');

      var anyActive = state.types.length || state.sizes.length || state.priceMin !== null || state.priceMax !== null;
      clearBtn.classList.toggle('is-visible', !!anyActive);

      if (emptyState) emptyState.classList.toggle('is-visible', visibleCount === 0);
    }

    function rescan() {
      var data = collectData();

      if (priceMinInput) priceMinInput.placeholder = Math.floor(data.minPrice / 100);
      if (priceMaxInput) priceMaxInput.placeholder = Math.ceil(data.maxPrice / 100);

      [['categoria', data.types, data.typeSet], ['tamanho', data.sizes, data.sizeSet]].forEach(function (group) {
        var key = group[0], values = group[1], countMap = group[2];
        var panel = bar.querySelector('[data-panel="' + key + '"]');
        if (!panel) return;

        values.forEach(function (v) {
          var selector = '.vp-filter-option input[data-key="' + key + '"][value="' + v.replace(/"/g, '\\"') + '"]';
          var existing = panel.querySelector(selector);
          if (existing) {
            var countSpan = existing.parentElement.querySelector('.vp-filter-pill__count');
            if (countSpan) countSpan.textContent = '(' + countMap[v] + ')';
          } else {
            var isSize = key === 'tamanho';
            var text = isSize ? displaySize(v) : v;
            var label = document.createElement('label');
            label.className = 'vp-filter-option';
            label.innerHTML = '<input type="checkbox" data-key="' + key + '" value="' + v.replace(/"/g, '&quot;') + '"><span>' + text + '</span><span class="vp-filter-pill__count">(' + countMap[v] + ')</span>';
            panel.appendChild(label);
            bindCheckbox(label.querySelector('input'));
          }
        });
      });

      applyFilters();
    }

    window.__vpRescanFilter[sectionId] = rescan;

    applyFilters();
  }

  function init() {
    document.querySelectorAll('.vp-filter-bar').forEach(initFilterBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
